import { render, staticRenderFns } from "./PVideo.vue?vue&type=template&id=54516d62&scoped=true"
import script from "./PVideo.vue?vue&type=script&lang=js"
export * from "./PVideo.vue?vue&type=script&lang=js"
import style0 from "./PVideo.vue?vue&type=style&index=0&id=54516d62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54516d62",
  null
  
)

export default component.exports